import * as interfaces from "../../interfaces";
import { DslElement } from "../common";

export abstract class DoStatement extends DslElement implements interfaces.IDoStatement {
  isDoSectionStatement: true = true as const;
  abstract toJson(): interfaces.IDoStatement;
  abstract toDsl(indent: number): string;
}
